import React, { useCallback } from 'react';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useGuestGuideTelemetry } from '../GuestGuideTelemetry';
import { useGetEventCTAButtonsDataLazyQuery } from '@graphql/generated';
import { useTranslation } from '@shared/core';
import { GuestGuideActionButton } from '../GuestGuideActionButton';
import { Gift } from '@withjoy/joykit/icons';

export const BrowseCouplesRegistryAction: React.FC = () => {
  const { eventHandle, eventInfo } = useEventInfo();
  const telemetry = useGuestGuideTelemetry();
  const { t } = useTranslation('guestGuide');
  const [getCtaData, { data: sessionData, called: calledCTA, loading: loadingCTA }] = useGetEventCTAButtonsDataLazyQuery({
    batchMode: 'fast',
    ssr: false,
  });

  React.useEffect(() => {
    if (eventHandle) {
      getCtaData({
        variables: { name: eventHandle },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventHandle]);

  const { registryPage } = sessionData?.eventByName || {};

  const handleClick = useCallback(() => {
    telemetry.clickBrowseRegistry();
  }, [telemetry]);

  if (loadingCTA || !calledCTA || !eventInfo || registryPage?.disabled === true) {
    return null;
  }

  return (
    <GuestGuideActionButton
      icon={<Gift />}
      as="a"
      href={`/${eventHandle}/registry`}
      onClick={handleClick}
    >
      {t('buttonTextRegistry')()}
    </GuestGuideActionButton>
  );
};
